import { useProductBase } from '../Product';

export const SuccessMessage = () => {
  const { product } = useProductBase();
  if (!product) return null;
  return <p>{`All good! Your feedback was added to your ${product.name} workspace`}</p>;
};
